var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-footer"},[_c('span',[_vm._v(_vm._s(_vm.post.title))]),_c('div',{staticClass:"post-votes"},[_c('vote',{attrs:{"type":"up","post":_vm.post}}),_c('vote',{attrs:{"type":"down","post":_vm.post}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }